import { round } from '@gp/utils/common';

export const getElementStyle = (
  element: Element,
  propertyName: string,
): any => {
  if (!element) return '';
  return window.getComputedStyle(element, null).getPropertyValue(propertyName);
};

export const getElementWidth = (element: Element): number => {
  const boxSizing = getElementStyle(element, 'box-sizing');
  let result: any =
    boxSizing === 'border-box'
      ? ['width']
      : [
          'width',
          'padding-left',
          'padding-right',
          'border-left',
          'border-right',
        ];
  result = result
    .map((propertyName: string) => getElementStyle(element, propertyName))
    .map(Number.parseFloat)
    .map((value: number) => (Number.isNaN(value) ? 0 : value))
    .reduce((current: number, next: number) => current + next);
  // return result as number;
  return round(result as number);
};

export const getElementHorizontalMargin = (element: Element): number => {
  let result = ['margin-left', 'margin-right']
    .map(getElementStyle.bind(null, element))
    .map(Number.parseFloat)
    .reduce((current, next) => current + next);
  result = round(result);
  return result;
};
